/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React, { useEffect, useState } from "react";
import { CloseIcon, ExpressServiceIcon, InfoIcon } from "../../../components/Icons";
import { useModal } from "../../../context/ModalContext";
import { StyledBookingFlowButton } from "../../containers/BookingScheduleContainer/BookingScheduleContainer.style";
import CustomLinearProgressBar from "./CustomLinearProgressBar";
import { BOOKING_FLOW_TYPE, MODALS } from "../../../config/params";
import { usePetStore } from "../../../hooks/redux-hooks/pet-store/pet-store.service";
import { useAppointmentStore } from "../../../hooks/redux-hooks/appointment-store/appointment.store";
import { ConfirmDoctorVisitToggleContainer, ExpressPetSelectionContainer } from "../../containers";
import ExpressBookingScheduleContainer from "../../containers/BookingScheduleContainer/ExpressBookingScheduleContainer";
import ExpressBookingReviewContainer from "../../containers/BookingReviewContainer/ExpressBookingReviewContainer";
import { useOverdueInvoiceStore } from "../../../hooks/redux-hooks/overdue-invoice-store/overdue-invoice.store";
import ExpressReasonForVisitContainer from "../../containers/ReasonForVisitContainer/ExpressReasonForVisitContainer";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { userActivityLogger } from "../../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../../config/mixPanelEvents";
import { ExpressAppointmentDetailsIndicator } from "../../../components";
import { useAppointmentCreateV2 } from "../../../services/create-appointment-v2/create-appointment-v2.service";
import SelectedTimeUnavailableModal from "../SelectedTimeUnavailableModal/SelectedTimeUnavailableModal";

const ExpressVisitModal = () => {
  const { closeModal, openModal, setAppointmentErrorCode } = useModal();
  const [activeStep, setActiveStep] = useState<number>(0);
  const { petList } = usePetStore();
  const { selectedPets, appointmentForm, setPromoCodeData, resetCurrentBookingStep,
    setSelectedPets, setAppointmentsForm, setReasonForVisit, reasonForVisit, currentStep } = useAppointmentStore();
  const [selectedSlot, setSelectedSlot] = useState<string>("");
  const [selectedDate, setSelectedDate] = useState<string>("");
  const [reasonUpdatePetIndex, setReasonUpdatePetIndex] = useState<number>();
  const { isBookingBlocked }=useOverdueInvoiceStore();
  const { createAppointmentV2, appointmentCreatedV2 } = useAppointmentCreateV2();
  const [disableButton, setDisableButton] = useState<boolean>(false);
  const [selectedReasons, setSelectedReasons] = useState<string[]>([]);
  const [showExpressWarning, setShowExpressWarning] = useState<boolean>(false);
  const [ineligiblePetName, setIneligiblePetname] = useState<string>("");

  const handleExpressWarning = (petName: string)=>{
    setShowExpressWarning(true);
    setIneligiblePetname(petName);
  };


  const handleCloseModal = ()=>{
    openModal(MODALS.CANCEL_BOOK_A_VISIT);
  };

  const handleConfirmBooking = () => {
    createAppointmentV2();
    localStorage.removeItem("isWebUser");
  };

  const handleReasonCtaClick = () => {
    if (reasonUpdatePetIndex) {
      onReasonSelection({
        petId: selectedPets[reasonUpdatePetIndex - 1]?.id,
        reasons: selectedReasons.join(","),
        anything: "",
      });
      userActivityLogger(MIXPANEL_EVENTS.EXPRESS_SERVICE_SELECT_REASON_CATEGORY,
        { appointment_category: "tech", pet_name: selectedPets[reasonUpdatePetIndex - 1]?.name, reason_type: selectedReasons.join(",") });
      setSelectedReasons([]);
      if (reasonUpdatePetIndex === selectedPets.length) {
        handleStep();
      } else {
        setReasonUpdatePetIndex(reasonUpdatePetIndex+1);
      }
    }
  };

  const onReasonSelection = (reason: any)=>{
    const reasonVisitUpdatedList = {
      ...reasonForVisit,
      [reason.petId]: { reasons: reason.reasons, anything: reason.anything,
        socReasons: reasonForVisit[reason.petId]?.socReasons,
      },
    };

    setReasonForVisit(reasonVisitUpdatedList);
  };

  const handleCtaClick = ()=>{
    switch (activeStep) {
    case 0:
      handleStep();
      break;
    case 1:
      handleReasonCtaClick();
      break;
    case 2:
      userActivityLogger(MIXPANEL_EVENTS.EXPRESS_SERVICE_FIND_TIME,
        { appointment_category: "tech",
          pet_name: selectedPets.map((pet) => pet.name).join(","),
          date: appointmentForm?.day,
          time_slot: appointmentForm?.selectedSlotLabel,
          no_of_pets: selectedPets.length,
        });
      handleStep(4);
      break;
    case 4:
      handleConfirmBooking();
      break;
    default:
      break;
    }
  };
  const handleBackStep = ()=>{
    switch (activeStep) {
    case 1:
      setSelectedReasons([]);
      setReasonForVisit({});
      setReasonUpdatePetIndex(1);
      handleStep(0);
      break;
    case 2:
      setSelectedReasons([]);
      setReasonForVisit({});
      setReasonUpdatePetIndex(1);
      handleStep(1);
      break;
    case 4:
      setAppointmentsForm(null);
      handleStep(2);
      break;
    default:
      break;
    }
  };

  const getCtaText = ()=>{
    switch (activeStep) {
    case 4:
      return "Confirm Booking";
    default:
      return "Continue";
    }
  };

  const disableValidation = (step: number): boolean => {
    switch (step) {
    case 0:
      return !selectedPets?.length;
    case 1:
      return disableButton || selectedReasons.length === 0;
    case 2:
      return appointmentForm?.time ? false : true;
    case 4:
      return isBookingBlocked;
    default:
      return false;
    }
  };

  const handleRedirectToPromoTerms = () => {
    window.open("http://goodvets.com/promotion-terms");
  };


  const handleStep = (step?: number) => {
    setActiveStep((step || step===0) ? step : activeStep + 1);
  };

  const singlePetConditionCheck = () => {
    if (petList) {
      if (petList.length === 1) {
        return activeStep !== 1 ? true : false;
      } else {
        return true;
      }
    }
  };

  const getStepDetail = (step: number) => {
    switch (step) {
    case 0:
      return (
        <ExpressPetSelectionContainer handleExpressWarning={handleExpressWarning} />
      );

    case 1:
      return (
        reasonUpdatePetIndex &&
        <ExpressReasonForVisitContainer
          reasonUpdatePetIndex={reasonUpdatePetIndex}
          setIsLoading={setDisableButton}
          selectedReasons={selectedReasons}
          setSelectedReasons={setSelectedReasons}
          setActiveStep={setActiveStep}
          setReasonUpdatePetIndex={setReasonUpdatePetIndex}
        />
      );
    case 2:
      return (
        <ExpressBookingScheduleContainer />
      );
    case 3:
      return (
        <ConfirmDoctorVisitToggleContainer setActiveStep={setActiveStep} setSelectedReasons={setSelectedReasons} />
      );
    case 4:
      return (
        <ExpressBookingReviewContainer
          activeStep={activeStep}
          setActiveStep={setActiveStep}
          selectedSlot={selectedSlot}
          setReasonUpdatePetIndex={setReasonUpdatePetIndex}
        />
      );
    default:
      return null;
    }
  };

  useEffect(() => {
    if (petList && petList.length == 0) {
      openModal(MODALS.ADD_A_PET);
    } else if (selectedPets.length == 0) {
      setActiveStep(0);
    } else if (selectedPets.length != 0 && !appointmentForm?.time) {
      setActiveStep(1);
    } else {
      setActiveStep(2);
    }
  }, []);

  useEffect(() => {
    if (appointmentCreatedV2) {
      if (appointmentCreatedV2.slotUnavailable) {
        setAppointmentErrorCode(appointmentCreatedV2?.messages[0]?.split(":")[0].toLowerCase());
        openModal(MODALS.SELECTED_TIME_UNAVAILABLE, BOOKING_FLOW_TYPE.DEDICATED_EXPRESS_FLOW);

        return;
      }
      setAppointmentErrorCode("");
      resetCurrentBookingStep();
      userActivityLogger(MIXPANEL_EVENTS.EXPRESS_SERVICE_BOOKING_CONFIRM,
        { appointment_category: "tech",
          pet_name: selectedPets.map((pet) => pet.name).join(","),
          date: appointmentForm?.day,
          time_slot: appointmentForm?.selectedSlotLabel,
          no_of_pets: selectedPets.length,
        });
      closeModal();
      openModal(MODALS.EXPRESS_BOOKING_CONFIRMATION_MODAL);
      // to reset the promocode state to default
      setPromoCodeData([]);
    }
  }, [appointmentCreatedV2]);

  useEffect(() => {
    if (selectedPets.length) {
      setReasonUpdatePetIndex(1);
    }
  }, [selectedPets]);

  useEffect(() => {
    if (appointmentForm?.day && appointmentForm?.selectedSlotLabel) {
      setSelectedDate(appointmentForm?.day);
      setSelectedSlot(appointmentForm?.selectedSlotLabel);
    } else {
      setSelectedDate("");
      setSelectedSlot("");
    }
  }, [appointmentForm]);

  useEffect(() => {
    if (showExpressWarning) {
      setTimeout(() => {
        setShowExpressWarning(false);
        setIneligiblePetname("");
      }, 1000);
    }
  }, [showExpressWarning]);

  if (currentStep === 5) {
    return (
      <div className="h-full">
        <SelectedTimeUnavailableModal />
      </div>
    );
  }

  return (
    <div className="h-full flex flex-col justify-between px-3">
      <div className="w-full flex justify-between">
        {(activeStep > 0) && (activeStep !== 3) && singlePetConditionCheck() ? (
          <ArrowBackIcon
            onClick={handleBackStep}
            className="text-light-black cursor-pointer"
          />
        ) : (
          <span></span>
        )}
        <CloseIcon
          onClick={handleCloseModal}
          className="text-light-black cursor-pointer"
        />
      </div>
      {activeStep !==3 &&
      <div className="flex flex-col gap-2 items-center">
        {showExpressWarning && ineligiblePetName.length &&
        <div className="flex gap-2 border border-gv-yellow w-[85%] bg-gv-yellow-light p-2 rounded-lg absolute text-sm itmes-center">
          <InfoIcon width={24} height={24} />
          <div className="mt-0.5">{`${ineligiblePetName} does not qualify for an Express Services yet.`}</div>
        </div>}
        <div className="flex items-center justify-center bg-taupe-4 rounded-full p-2 h-fit">
          <ExpressServiceIcon width={40} height={40} />
        </div>
        <div className="flex flex-col items-center gap-1">
          <div className="font-semibold text-2xl">
            Express Services
          </div>
          <div className="text-xs text-center">
          Quick, routine technician led care for services like repeat injections,
          nail trims, or vaccine boosters.
          </div>
        </div>
      </div>}
      {activeStep !==3 &&
      <div className="my-4 w-full flex flex-col gap-3">
        <CustomLinearProgressBar totalSteps={(petList && petList.length === 1) ? 3 :4} currentStep={(petList && petList.length === 1) ? activeStep-1 :activeStep} />
        <ExpressAppointmentDetailsIndicator />
      </div>}
      <div className="h-full flex flex-col gap-2 items-center
      justify-between min-h-0 overflow-y-auto !w-full px-2 scrollbar-thin">
        {getStepDetail(activeStep)}
      </div>
      {activeStep !==3 &&
      <div className="flex flex-col gap-2 pb-1 pt-1.5 mt-2">
        <StyledBookingFlowButton
          color="primary"
          disabled={disableValidation(activeStep)}
          size="small"
          className="w-full"
          onClick={handleCtaClick}
        >
          {getCtaText()}
        </StyledBookingFlowButton>
        {activeStep === 4 &&
        <div className="text-xs text-center" onClick={handleRedirectToPromoTerms}>
            By continuing, you agree to the{" "}
          <span className="font-semibold underline decoration-1 underline-offset-2 cursor-pointer">

               GoodVets Promotions <br />Terms of Service
          </span>
        </div>}
      </div>}
    </div>
  );
};

export default ExpressVisitModal;
